import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, map } from 'rxjs';
import { CommonResponse } from 'src/app/models/commomResponse';
import {
  driverData,
  driverListResponse,
  driverOrderListResponse,
  driverTransactionListResponse
} from 'src/app/models/driverData';
import { ExportCsvResponse } from 'src/app/models/exportCsvResponst';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class driverService {
  constructor(private http: HttpClient) { }

  statusDetails: BehaviorSubject<number | null> = new BehaviorSubject<
    number | null
  >(null);

  getDriverById(id: string | null): Observable<driverData> {
    return this.http
      .get<{ data: driverData }>(`${environment.base_url}driver/${id}`)
      .pipe(map(res => res.data));
  }

  addDriver(data: driverData): Observable<CommonResponse> {
    return this.http.post<CommonResponse>(
      `${environment.base_url}driver`,
      data
    );
  }

  getDrivers(query: string): Observable<any> {
    return this.http
      .get<{
        data: any;
      }>(`${environment.operational_url}allDrivers?${query}`)
      .pipe(map(res => res.data));
  }
  submitDriverCash(data: any): Observable<any> {
    return this.http.post<any>(`${environment.base_url}driver/submitCash`, data);
  }

  getDriverOrders(
    id: string | null,
    query: string
  ): Observable<driverOrderListResponse> {
    return this.http
      .get<{
        data: driverOrderListResponse;
      }>(`${environment.base_url}driverDetails/${id}?${query}`)
      .pipe(map(res => res.data));
  }

  updateDriver(
    data: driverData | { isApproovedByAdmin?: number; isBlocked?: boolean },
    id: string
  ): Observable<CommonResponse> {
    return this.http.put<CommonResponse>(
      `${environment.base_url}driver/${id}`,
      data
    );
  }

  getDriverList(data: string): Observable<driverListResponse> {
    return this.http
      .get<{
        data: driverListResponse;
      }>(`${environment.base_url}driver?${data}`)
      .pipe(map(res => res.data));
  }

  deleteDriver(id: string): Observable<number> {
    return this.http
      .delete<{ statusCode: number }>(`${environment.base_url}driver/${id}`)
      .pipe(map(res => res.statusCode));
  }
  exportCsv(query: string): Observable<ExportCsvResponse> {
    return this.http.get<ExportCsvResponse>(
      `${environment.base_url}driverExport?${query}`
    );
  }

  getWalletTransactions(query: string): Observable<driverTransactionListResponse> {
    return this.http.get<{
      data: driverTransactionListResponse;
    }>(`${environment.operational_url}driver-transactions?${query}`).pipe(map(res => res.data));
  }

  // Method to get driver locations - for future implementation when API is available
  getDriverLocations(query: string): Observable<any> {
    return this.http.get<{
      data: any;
    }>(`${environment.base_url}driver-locations?${query}`).pipe(map(res => res.data));
  }

  getDriverReport(id: string, query: string): Observable<driverTransactionListResponse> {
    return this.http.get<{
      data: driverTransactionListResponse;
    }>(`${environment.operational_url}reportDriverWise/${id}?${query}`).pipe(map(res => res.data));
  }
}
